import DataTable from 'react-data-table-component';
import React from 'react'
import { FaFilePdf, FaFileSignature, FaCheckCircle, FaExclamationTriangle } from "react-icons/fa";
import { AiOutlineFileDone, AiOutlineFileExclamation } from "react-icons/ai";
import Statusall from '../componentallstatus/statusall';
import ViewJournaldetail from './viewJournaldetail';
import PopUpCheckList from '../componentjournallistrecieved/popUpCheckList';
import TdsCodeCell from '../TdsCodeCell';

const columns = [
    {
        name: 'E-Code',
        sortable: true,
        width: '110px',
      
        selector: row => row.tdscode,
        cell: row => <TdsCodeCell tdscode={row.tdscode} revision={row.revision} />,
    },

    {
        name: 'Date',
        sortable: true,
        selector: row => row.createdate,
       
        width: '100px',
    },
    {
        name: 'approve date',
        sortable: true,
        selector: row => row.dateconfirm,
        width: '120px',
    },
    {
        name: 'customer/product',
        grow: 3.5,
        reorder: true,
        selector: row => <div>
            <div>: {row.journaltype}</div>
            <div>: {row.customername}</div>
            <div>: {row.productname}</div>
            <div>: {row.productgrouptype} <label style={{ color: 'red' }}>({row.createbyName})</label></div>
        </div>
        ,
    },
    {
        name: 'film code',
        selector: row => row.filmcode,
        grow: 1.5,
    },
    {
        name: 'status flow',
        sortable: true,
        selector: row => row.statusflow === '0000'
            ? <span style={{
                display: 'inline-flex', alignItems: 'center', gap: 5,
                backgroundColor: '#fee2e2', color: '#b91c1c',
                border: '1px solid #fca5a5', borderRadius: 20,
                padding: '3px 10px', fontWeight: 700, fontSize: 11,
                whiteSpace: 'nowrap',
            }}>
                <FaExclamationTriangle size={10} /> ยกเลิกเอกสาร
            </span>
            : <Statusall id={row.journalId} statusNow={row.stateflow} stateSuccesfull={row.stateSuccesfull} />,
        grow: 1.5,
    },

    {
        name: 'job status',
        selector: row => (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 5, padding: '4px 0' }}>
                {Number(row.statusprove_Tds) === 1 && (
                    <span style={{
                        display: 'inline-flex', alignItems: 'center', gap: 4,
                        backgroundColor: '#198754', color: '#fff',
                        borderRadius: 12, padding: '3px 9px',
                        fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap'
                    }}>
                        <FaCheckCircle size={10} /> Proof Job
                    </span>
                )}
                {row.QuarityStatus > 0 && (
                    <PopUpCheckList tdsCode={row.tdscode} />
                )}
            </div>
        ),
        width: '155px',
    },
    {
        name: 'confirm job',
        width: '110px',
        selector: row => (
            <div>
                {Number(row.statusConfirm) === 1 && (
                    <span style={{
                        display: 'inline-flex', alignItems: 'center', gap: 4,
                        backgroundColor: '#198754', color: '#fff',
                        borderRadius: 12, padding: '3px 10px',
                        fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap'
                    }}>
                        <FaCheckCircle size={10} /> Approve
                    </span>
                )}
            </div>
        ),
    },

    {
        name: 'action',
        grow: 1,
        cell: row => <div className='row-page'>
            <ViewJournaldetail jourId={row.journalId} codeId={row.tdscode} revise={row.revision} />

            {row.stateflow > row.stateSuccesfull ?
                <div style={{ marginLeft: 2 }}>
                    <center>
                        <a href={`/journalPDFAll/${row.journalId}`}><AiOutlineFileDone size={25} color='#08ab54' /></a>
                    </center>
                </div> :
                <div>
                    <div style={{ marginLeft: 2 }}>
                        <center>
                            <a href={`/draftjournalpdfAll/${row.journalId}`}><AiOutlineFileExclamation size={25} color='#EF5635' /></a>
                        </center>
                    </div>
                </div>
            }

        </div>,
    },

];

const customStyles = {
    headRow: {
        style: {
            border: 'none',
            backgroundColor: '#28B463'
        },
    },
    headCells: {
        style: {
            color: '#ffff',
            fontSize: '14px',
        },
    },
    rows: {
        highlightOnHoverStyle: {
            backgroundColor: 'rgb(230, 244, 244)',
            borderBottomColor: '#FFFFFF',
            borderRadius: '25px',
            outline: '1px solid #FFFFFF',
        },
    },
    pagination: {
        style: {
            border: 'none',
        },
    },
    cells: {
        style: {
            paddingLeft: '2px', // override the cell padding for data cells
            paddingRight: '2px',
            fontSize: '12px',
        },
    },
};

const Tablelistallprovebyuser = ({ datatable }) => {
    var dataresult = datatable;
    return (
        <DataTable
            columns={columns}
            data={dataresult}
            // selectableRows
            pagination
            customStyles={customStyles}
            highlightOnHover

        />
    )
}

export default Tablelistallprovebyuser